import { BookOpen, Calculator, Trophy } from 'lucide-react';

interface StatItemProps {
  icon: React.ComponentType<{ className?: string }>;
  iconColor: string;
  label: string;
}

const StatItem = ({ icon: Icon, iconColor, label }: StatItemProps) => (
  <div
    aria-label={`${label} - informational`}
    className="flex flex-col items-center gap-1 md:gap-2 p-2 md:p-4 card-informational rounded-lg cursor-default opacity-80"
    role="img"
  >
    <div className="flex items-center justify-center w-6 h-6 md:w-8 md:h-8 rounded-full card-informational">
      <Icon aria-hidden="true" className={`w-4 h-4 md:w-5 md:h-5 ${iconColor}`} />
    </div>
    <div className="text-center">
      <div className="text-xs md:text-sm text-secondary font-medium">
        {label}
      </div>
    </div>
  </div>
);

const StatsSection = () => {
  const stats = [
    {
      icon: BookOpen,
      iconColor: 'text-semantic-success',
      label: '700+ Math Topics',
    },
    {
      icon: Calculator,
      iconColor: 'text-brand-primary',
      label: 'Fun Challenges',
    },
    {
      icon: Trophy,
      iconColor: 'text-semantic-warning',
      label: 'Be a Math Hero',
    },
  ];

  return (
    <div className="flex flex-wrap justify-center gap-2 md:gap-4 mt-6">
      {stats.map((stat, index) => (
        <StatItem
          icon={stat.icon}
          iconColor={stat.iconColor}
          key={index}
          label={stat.label}
        />
      ))}
    </div>
  );
};

export default StatsSection;
